export enum apiUrlShared {
    PRE_SIGNED = 'v1/pre_signed_link',
    APPLY_PROMO_CODE = 'v1/verify-promotion-code',
    DEVICE_REGISTER = 'v1/notifications/device_register/',
}
